import { Link } from "react-router-dom";

const ROSE_EMBLEM = "https://customer-assets.emergentagent.com/job_wine-tech-hub/artifacts/0pnaev76_LOGO_WT_ROSE%403x%20%281%29.png";
const WHITE_EMBLEM = "https://customer-assets.emergentagent.com/job_wine-tech-hub/artifacts/o0kw7gdu_LOGO_WT_WHITE%403x%20%281%29.png";

/**
 * La WineTech brand logo. Uses official brand PNGs (transparent background).
 * variant="dark" → white emblem (for dark surfaces).
 */
export default function Logo({ variant = "light", linkTo = "/", showWordmark = true, size = "md", className = "" }) {
  const isDark = variant === "dark";
  const emblem = isDark ? WHITE_EMBLEM : ROSE_EMBLEM;
  const sizeCls = size === "lg" ? "h-14 w-14" : size === "sm" ? "h-9 w-9" : "h-11 w-11";

  const inner = (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img src={emblem} alt="La WineTech" className={`${sizeCls} shrink-0 object-contain`} />
      {showWordmark && (
        <div className="leading-tight">
          <div className={`text-base font-bold tracking-[0.01em] ${isDark ? "text-white" : "text-navy"}`}>
            La <span className="text-wine-500">WineTech</span>
          </div>
          <div className={`mt-0.5 text-[10px] font-medium uppercase tracking-[0.22em] ${isDark ? "text-white/70" : "text-wine-600"}`}>
            Innovate Together
          </div>
        </div>
      )}
    </div>
  );

  return linkTo ? <Link to={linkTo} className="inline-flex">{inner}</Link> : inner;
}
